import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'stencil-icon-button',
  styleUrl: 'stencil-icon-button.css',
  shadow: true,
})
export class StencilIconButton {
  @Prop() iconName: string;
  //@Prop() onClick: () => void;
  @Prop() onClick: (event: MouseEvent) => void;

  @Prop() iconClassName: string;
  @Prop() tooltip: string;
  @Prop() icon: any; // Removed the default value
  @Prop() secondary: boolean = false;
  @Prop() noBackground: boolean = false;
  @Prop() noTooltip: boolean = false;
  @Prop() darkIcon: boolean = true;
  @Prop() showLabel: boolean = true;
  @Prop() disabled: boolean = false;
  @Prop() buttonId: string;

  render() {
    let buttonClass = this.secondary ? 'icon-button-secondary' : 'icon-button'; // conditional class
    let buttonStyle = this.showLabel ? {} : { paddingLeft: '10px', paddingRight: '10px' }; // conditional style

    // Use the 'noBackground' prop to add another conditional class
    if (this.noBackground) {
      buttonClass += ' no-background';
    }

    // Your existing code for setting up the icon
    const iconColor = this.darkIcon ? 'black' : 'white';
    const iconData = this.icon; // Removed the default value
    return (
      <udp-ambient-tool-tip content={this.showLabel ? '' : this.tooltip} noTooltip={this.noTooltip}>
        <button disabled={this.disabled} class={buttonClass} onClick={this.onClick} title={this.showLabel ? this.tooltip : null} style={buttonStyle} id={this.buttonId}>
          {/* Conditionally render the icon if one is provided */}
          {iconData && (
            <svg {...iconData.attrs} fill={iconColor}>
              {iconData.content.map((item, index) => {
                if (item.elem === 'path') {
                  return <path {...item.attrs} key={index} />;
                } else if (item.elem === 'circle') {
                  return <circle {...item.attrs} key={index} />;
                }
                return null;
              })}
            </svg>
          )}
          {this.showLabel && <slot></slot>}
        </button>
      </udp-ambient-tool-tip>
    );
  }
}
